<template>
  <div>
    <div class="contact">
      <p>{{ details.message }}</p>
      <p class>
        {{ details.name }}
        <br />
        {{ details.address1 }}
        <br />
        {{ details.address2 }}
        <br />
        {{ details.country }}
        <br />
        <br />
        {{ details.phone1 }}
        <br />
        {{ details.phone2 }}
        <br />
        <br />
        {{ details.email }}
        <br />
      </p>
    </div>
    <div id="map" class="mx-auto"></div>
  </div>
</template>

<script>
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState(["config"]),
    details() {
      return {
        name: this.config.name,
        address1: this.config.address1,
        address2: this.config.address2,
        phone1: this.config.phone1,
        phone2: this.config.phone2,
        email: this.config.email,
        country: this.config.country,
        message: this.config.contactMsg,
        coords: this.$_.map(
          this.$_.split(this.config.coordinates, ","),
          parseFloat
        ),
      };
    },
  },
  mounted() {
    let map = L.map("map", {
      center: this.details.coords,
      zoom: 15,
      maxZoom: 15,
    });
    var Stamen_Watercolor = L.tileLayer(
      "https://tile.openstreetmap.org/{z}/{x}/{y}.png",
      {
        maxZoom: 19,
        attribution:
          '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      }
    ).addTo(map);
    L.circleMarker(this.details.coords, { radius: 10, color: "#42b983" }).addTo(
      map
    );
  },
};
</script>

<style>
#map {
  min-height: 30em;
  display: block;
}
.contact {
  text-align: center;
}
</style>

